var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ShieldLockFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconShieldLockFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.314 1C20.9833 1 21.557 1.28684 21.9395 1.6693C22.4175 2.05175 22.6088 2.62544 22.8 3.19912V7.88421C22.8 11.1351 21.8439 14.1947 20.0272 16.7763C18.2105 19.3579 15.7246 21.3658 12.7605 22.5132C12.4737 22.6088 12.1868 22.7044 11.9 22.7044C11.6132 22.7044 11.3263 22.6088 11.0395 22.5132C8.07544 21.3658 5.58947 19.3579 3.77281 16.7763C1.95614 14.0991 1 11.0395 1 7.88421V3.19912C1 2.62544 1.19123 2.05175 1.57368 1.6693C2.05175 1.19123 2.62544 1 3.19912 1H20.314ZM14.386 16.2982C15.6289 16.2982 16.4895 15.3421 16.4895 14.1947V10.2746C16.4895 9.41404 15.9158 8.64912 15.1509 8.36228V7.59737C15.1509 5.58947 13.7167 4.15526 11.8044 4.15526C9.89211 4.15526 8.36228 5.68509 8.36228 7.50175V8.26667C7.59737 8.55351 7.02368 9.31842 7.02368 10.1789V14.1947C7.02368 15.3421 7.97982 16.2982 9.12719 16.2982H14.386ZM13.7162 7.50155C13.7162 6.35418 12.8556 5.49365 11.8039 5.49365C10.7521 5.49365 9.8916 6.35418 9.8916 7.50155V8.07523H13.7162V7.50155ZM14.4807 9.60498H9.12633C8.74387 9.60498 8.45703 9.89182 8.45703 10.1787V14.1945C8.45703 14.5769 8.74387 14.8638 9.12633 14.8638H14.4807C14.8632 14.8638 15.15 14.5769 15.15 14.1945V10.1787C15.0544 9.79621 14.8632 9.60498 14.4807 9.60498ZM11.8035 13.2383C11.2298 13.2383 10.7518 12.7602 10.7518 12.1866C10.7518 11.6129 11.2298 11.1348 11.8035 11.1348C12.3772 11.1348 12.8553 11.6129 12.8553 12.1866C12.8553 12.7602 12.3772 13.2383 11.8035 13.2383Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconShieldLockFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconShieldLockFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconShieldLockFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-shield-lock-filled') === undefined) {
    customElements.define('cat-icon-shield-lock-filled', BlocksIconShieldLockFilled);
}
